import { createSlotRecipe } from './runtime.js';

const chatActionBarConfig = {"name":"chatActionBar","slots":["root"]}

export const chatActionBar = /* @__PURE__ */ createSlotRecipe(chatActionBarConfig)